module.exports = __webpack_public_path__ + "img/gaoyuxian.5feb5c1f.png";